'use client';
import client from '@s7/http';
import { InMemoryCache } from '../cache/in-memory-cache.js';

const DEFAULT_CLIENT = client;
const DEFAULT_CACHE = InMemoryCache;

export { DEFAULT_CACHE, DEFAULT_CLIENT };
//# sourceMappingURL=defaults.js.map
